import { useLocalStore } from 'mobx-react-lite';

import Entities from 'STORE';

interface ISpaceBadgePresenterPresenter {
  hasNewMessages: boolean;
}

export function useSpaceBadgePresenter(): ISpaceBadgePresenterPresenter {
  return useLocalStore(() => ({
    get hasNewMessages(): boolean {
      return Entities.GroupsStore.rawGroups.some(
        (group) => group.spaceId && (group.numberOfUnread > 0 || group.unread) && !group.muted
      );
    },
  }));
}
